"use strict";

window._theme = window._theme || {};

class ViewTrack {
  constructor() {
    window.dataLayer = window.dataLayer || [];
    this.isMobile = window.innerWidth < 768 ? true : false;
  }

  init = () => {
    this.buildSelectors();
    this.initViewTrackEvents();
    this.initClickTrackEvent();
    this.initHoverTrackEvent();
    this.init404PageTrackEvent();
  }

  initOnLoad = () => {
    const listrakModalBtn = document.getElementById("ltkPopupTriggerButton");
    if (listrakModalBtn) this.trackView("Listrak newsletter model");
  }

  buildSelectors = () => {
    this.selectors = {};
    
    this.selectors.viewTrackElements = [
      {
        elem: document.getElementById("shopify-section-announcement-bar"),
        msg: "Announcement-bar",
        trackView: true,
        trackClick: false
      },
      {
        elems: Array.from(document.querySelectorAll(".shopify-section.home-slideshow-sections .slideshow-banner-img")),
        msg: "Hero banner",
        trackView: true,
        trackClick: true
      },
      {
        elem: document.querySelector(".shopify-section.section--home-brands"),
        msg: "Brands slider",
        trackView: true,
        trackClick: false
      },
      {
        elems: Array.from(document.querySelectorAll('.shopify-section.home-top-banner-sections .home-sub-banner .item')),
        msg: "Home collection",
        trackView: true,
        trackClick: false
      },
      {
        elem: document.querySelector(".template-collection .pro-bann-grid.visible-desktop"),
        msg: "Collection product grid banner",
        trackView: true,
        trackClick: false
      },
      {
        elem: document.querySelector(".product-shop .product-label-mix-match"),
        msg: "2 for $99 | Mix & Match",
        trackView: true,
        trackClick: false
      }
    ];

    this.selectors.hoverTrackElements = [
      {
        elems: document.querySelectorAll('.inner.product-item .product-quick-add'),
        msg: "Quick view"
      }
    ]
  }

  initViewTrackEvents = () => {
    const callbackFn = (entries, observer) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          let targetIndex = 0;
          const target = entry.target;
          const item = this.selectors.viewTrackElements.find((item) => {
            if(item.elem) return item.elem === target;

            if(item.elems) return item.elems.find((elem, index) => {
              if(elem === target){
                targetIndex = index + 1;
                return true;
              }

              return false;
            });
          });

          const eventText = targetIndex !== 0 ?  `${item.msg} ${targetIndex}` : item.msg;
          this.trackView(eventText);
          observer.unobserve(target);
        }
      });
    };

    const observerIns = new IntersectionObserver(callbackFn, {
      root: null,
      rootMargin: "0px 0px 0px 0px",
      threshold: 0.80,
    });

    this.selectors.viewTrackElements.forEach((item) => {
      if(!item.trackView) return;

      if (item.elem) observerIns.observe(item.elem);
      if (item.elems) {
        item.elems.forEach(itemElem => {
          observerIns.observe(itemElem);
        });
      }
    });
  }

  initClickTrackEvent = () => {
    this.selectors.viewTrackElements.forEach((item) => {
      if(!item.trackClick) return;
      
      if (item.elem) {
        item.elem.addEventListener('click', this.handleTrackClick);
      }

      if (item.elems) {
        item.elems.forEach(itemElem => {
          itemElem.addEventListener('click', this.handleTrackClick);
        });
      }
    });
  }

  initHoverTrackEvent = () => {
    if(this.isMobile) return;

    const pathname = window.location.pathname;
    if(!pathname.includes('/collections/') && !pathname.includes('/pages/search-results-page')) return;

    this.selectors.hoverTrackElements.forEach(item => {
      if(item.elems) {
        let timer;
        item.elems.forEach(elem => {
          elem.addEventListener('mouseenter', evt => {
            timer = setTimeout(() => {
              const hasQuickAddBtn = elem.querySelector('.quick-add-v');
              if(!hasQuickAddBtn) return;
              this.trackView(item.msg);
            }, 300);
          });

          elem.addEventListener('mouseleave', evt => {
            clearTimeout(timer);
          });
        });
      }
    });
  }

  handleTrackClick = (evt) => {
    evt.preventDefault();
    this.trackClick();
    const target = evt.target;
    const parentElem = evt.target.parentElement;
    let eventText = target.dataset.eventText || parentElem.dataset.eventText || "Hero Banner Click";

    this.trackClick(eventText);

    if(parentElem.nodeName === "A"){
      setTimeout(() => {
        window.location.href = parentElem.href;
      }, 250);
    }
  }

  init404PageTrackEvent = () => {
    const body = document.body;
    if (!body || body.getAttribute("data-template") !== "404") return;

    setTimeout(() => {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: '404_page',
        pageUrl: window.location.href,
        pageReferrer: document.referrer || 'Direct'
      });
    }, 300);
  };

  /**
   * @param {string} title 
   * @param {number} index 
   * @returns void
   */
  trackView = (title, index) => {
    if (!title) return;

    try {
      window.dataLayer.push({
        event: "banner_view",
        banner_name: title,
        banner_index: index || 0,
      });
    } catch (error) {
      console.warn('Error while tracking view');
    }
  }

  /**
   * @param {string} title 
   * @param {number} index 
   * @returns void
   */
  trackClick = (title, index) => {
    if (!title) return;

    try {
      window.dataLayer.push({
        event: "banner_click",
        bannername_: title,
        bannerindex: index || 0,
      });
    } catch (error) {
      console.warn('Error while tracking click');
    }
  }

  /**
   * @param {{productTitle: string, variantTitle: string, variantPrice: number}} data 
   * @returns void
   */
  trackQuickView = (data) => {
    if(!data.productTitle || !data.variantTitle || !data.variantPrice) return;

    window.dataLayer.push({
      event: "quickview",
      product_name: data.productTitle,
      product_variant: data.variantTitle,
      product_price: data.variantPrice
    });
  }

  /**
   * 
   * @param {string} event 
   * @param {string} method 
   */
  trackEvent = (event, method) => {
    if(!event || !method) return;

    window.dataLayer.push({
      event: event,
      method: method
    });
  }

  /**
   * 
   * @param {{}} data 
   * @returns void
   */
  trackData = (data = {}) => {
    if(!data || typeof data !== "object") return;

    window.dataLayer.push({
      ...data
    });
  }

}

_theme.track = new ViewTrack();

document.addEventListener("DOMContentLoaded", function (event) {
    _theme.track.init();
});

window.onload = function () {
  _theme.track.initOnLoad();
};
